/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): index.umd.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import Tab from './src/tab'

export default {
  Tab
}
